<template>
  <div class="h-full bg-gradient-to-br from-blue-50 to-indigo-50">
    <!-- 页面标题 -->
    <div class="mb-[8px] text-center pt-10">
      <h1 class="text-4xl font-bold text-[#fff] mb-[4px]">部署平台</h1>
    </div>

    <!-- 权限验证界面 -->
    <Auth v-if="!isAuthorized" @success="handleAuthSuccess" />

    <!-- 环境列表组件 -->
    <EnvList v-else />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import EnvList from "./components/EnvList.vue";
import Auth from "./components/Auth.vue";

const isAuthorized = ref(false);

const handleAuthSuccess = (token: string) => {
  isAuthorized.value = true;
  // 可以选择将 token 存储在 localStorage 中
  localStorage.setItem("access_token", token);
};

onMounted(() => {
  // 初始化时检查是否有已存储的 token
  const savedToken = localStorage.getItem("access_token");
  if (savedToken) {
    // 这里简单处理为已验证，实际生产中可能需要调用后端校验接口
    isAuthorized.value = true;
  }
});
</script>
